export enum BreakpointTypes {
  ThreeXL = "ThreeXL",
  TwoXL = "TwoXL",
  XL = "XL",
  LG = "LG",
  MD = "MD",
  SM = "SM",
  MOBILE = "MOBILE",
}
